import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb8a0380")

_pushScopeId("data-v-fb8a0380")
const _hoisted_1 = { class: "FTLOrderConfirmation" }
const _hoisted_2 = { class: "FTLOrderConfirmation__layer" }
const _hoisted_3 = { class: "FTLOrderConfirmation__cost" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "cost__label" }, "Стоимость заказа", -1)
const _hoisted_5 = { class: "cost__number" }
const _hoisted_6 = { class: "FTLOrderConfirmation__actions" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "actions__label" }, "Пожалуйста, подтвердите заказ", -1)
const _hoisted_8 = { class: "actions__buttons" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Отменить заказ ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Подтвердить заказ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_green_layer = _resolveComponent("icon-green-layer")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_icon_green_layer)
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.cost) + " ₸", 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_s_button, {
          onClick: _ctx.emitCancel,
          loading: _ctx.loading,
          class: "transparent"
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        _createVNode(_component_s_button, {
          onClick: _ctx.emitConfirm,
          loading: _ctx.loading,
          class: "green"
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ])
  ]))
})